module.exports = __webpack_public_path__ + "static/media/dykking.074037b9.png";